import { createRouter, createWebHistory } from 'vue-router'
import { useAuth } from '../composables/useAuth.js'

const routes = [
  {
    path: '/login',
    name: 'login',
    component: () => import('../pages/Login.vue'),
    meta: { public: true },
  },
  {
    path: '/',
    component: () => import('../layouts/AppShell.vue'),
    children: [
      { path: '',           name: 'dashboard', component: () => import('../pages/Dashboard.vue') },
      { path: 'changelog',  name: 'changelog', component: () => import('../pages/Changelog.vue') },
      // BL142e-7 P-B0: 链路追踪独立完整版面 (trace map 升格主体, 双轨过渡)
      { path: 'trace-map',  name: 'trace-map', component: () => import('../pages/TraceMap.vue') },
      { path: 'pnl',        name: 'pnl',       component: () => import('../pages/Pnl.vue') },
      { path: 'positions',  name: 'positions', component: () => import('../pages/Positions.vue') },
      { path: 'reconcile',  name: 'reconcile', component: () => import('../pages/Reconcile.vue') },
      { path: 'dataflow',   name: 'dataflow',  component: () => import('../pages/Dataflow.vue') },
      { path: 'blueprint',  name: 'blueprint', component: () => import('../pages/Blueprint.vue') },
    ],
  },
  // SPA catch-all (fallback to dashboard)
  { path: '/:pathMatch(.*)*', redirect: '/' },
]

const router = createRouter({
  history: createWebHistory(),
  routes,
})

router.beforeEach(async (to) => {
  const { state, refresh } = useAuth()
  // 公开路由 (Login) 直接放行,不阻塞首屏 whoami 调用
  // turn17 首屏优化: 原先 / -> /login 重定向也得等 whoami (~0.8s RTT) 才能渲染,
  // 现在 public 路径完全 skip await,让 Login 卡片在 JS 一到就显示;
  // 若已登录访问 /login,whoami 后台异步刷新,完成后主动 router.replace 跳 dashboard
  if (to.meta?.public) {
    // 已 init 且已登录: 同步 redirect 到 /
    if (state.initialized && state.email && to.name === 'login') {
      return { path: '/' }
    }
    // 未 init: 异步触发 refresh (不 await),Login 渲染不卡;
    // refresh resolve 后若当前路由仍是 login 且已登录,主动 router.replace 跳 /
    // (codex round REVISE 修正: 不再依赖"路由二次拦截",必须主动 replace)
    if (!state.initialized) {
      refresh().then(() => {
        if (router.currentRoute.value.name === 'login' && state.email) {
          void router.replace({ path: '/' })
        }
      })
    }
    return true
  }
  // 受保护路由:必须等 whoami 完成判定有无 session
  if (!state.initialized) {
    await refresh()
  }
  if (!state.email) return { path: '/login' }
  return true
})

export default router
